import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import ConfirmationModal from '../ConfirmationModal';
import ReadMoreComponent from '../ReadMoreComponent';
import agent from '../../agent';
import { Link, useNavigate } from 'react-router-dom';

const SocialListComponent = (props) => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedSocial, setSelectedSocial] = useState(null);
  const [socialFeed, setSocialFeed] = useState([]);

  const fetchSocialFeed = async () => {
    const username = props.forUsername?.replace('@', '');
    const results = await agent.Feeds.list(props.social, username);
    setSocialFeed(results);
  };

  useEffect(() => {
    fetchSocialFeed();
  }, [props.isAddingFeed]);

  const handleOpenModal = (social) => {
    setModalOpen(true);
    setSelectedSocial(social);
  };

  const handleDelete = async () => {
    await agent.Feeds.disconnectSocial(selectedSocial.id);
    const results = await agent.Feeds.list(props.social);
    setSocialFeed(results);
    setModalOpen(false);
  };

  if (!socialFeed?.length) return null;

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {socialFeed.map((social) => (
          <Box
            key={social.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 1.5,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.07)',
            }}
          >
            <Avatar
              alt={social.title}
              src={social.thumbnail}
              sx={{ width: 40, height: 40, flexShrink: 0, border: `1.5px solid ${DEFAULT_THEME_COLOR}44` }}
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ color: 'white', fontWeight: 600, fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {social.title}
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.75rem' }}>
                {social.name}
              </Typography>
              {social.description && (
                <Box sx={{ mt: 0.25 }}>
                  <ReadMoreComponent text={social.description} maxChars={80} />
                </Box>
              )}
            </Box>

            {props.showFeedButton && (
              <IconButton
                size="small"
                onClick={() => navigate('/settings', { state: { youtube: social.forHandle } })}
                sx={{ color: DEFAULT_THEME_COLOR, '&:hover': { background: `${DEFAULT_THEME_COLOR}22` } }}
              >
                <DynamicFeedIcon fontSize="small" />
              </IconButton>
            )}
            {props.showSubscribeButton && (
              <IconButton
                size="small"
                component={Link}
                target="_blank"
                rel="noopener"
                to={`https://www.youtube.com/${social.forHandle}`}
                sx={{ color: '#FF0000', '&:hover': { background: 'rgba(255,0,0,0.1)' } }}
              >
                <SubscriptionsIcon fontSize="small" />
              </IconButton>
            )}
            {!props.hideDelete && (
              <IconButton
                size="small"
                onClick={() => handleOpenModal(social)}
                sx={{ color: 'rgba(255,255,255,0.3)', '&:hover': { color: '#f87171' } }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        ))}
      </Box>

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleDelete}
        hideUndone={true}
      />
    </>
  );
};

export default SocialListComponent;
